import { useMediaQuery, Grid, Divider, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { DescriptionCta } from '@/src/components/molecules';
import { Section } from '@/src/components/organisms';
import { WsyiwygViewer } from '@/src/components/widgets';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    '& .description-cta__button-group': {
      flexWrap: 'nowrap',
    },
  },
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  fontWeightBold: {
    fontWeight: 'bold',
  },
  divider: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(5, 0),
    },
  },
  textWhite: {
    color: 'white',
  },
  cardHighlighted: {
    background: theme.palette.background.footer,
  },
  checkBox: {
    background: 'transparent',
    borderRadius: 0,
    width: 30,
    height: 30,
  },
  list: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  link: {
    color: theme.palette.primary.main,
  },
}));

const CompanyPrivacy = ({ data }) => {
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });
  const { validFrom = null, content } = data || {};

  const date = new Date(validFrom);
  const formattedDate = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(date);

  return (
    <div className={classes.root}>
      <Section className={classes.pagePaddingTop}>
        <>
          <DescriptionCta
            title="Política de privacidade"
            subtitle={`Atualizado em ${formattedDate}`}
            primaryCta={
              <Button
                aria-label="Imprimir"
                variant="outlined"
                color="primary"
                size="large"
                onClick={() => window.print()}>
                Imprimir
              </Button>
            }
            align="left"
            titleProps={{
              className: classes.fontWeightBold,
              color: 'textPrimary',
            }}
            subtitleProps={{
              color: 'textSecondary',
            }}
          />
          <Divider className={classes.divider} />
          <Grid container spacing={isMd ? 4 : 2}>
            <Grid item xs={12}>
              <WsyiwygViewer value={content} />
            </Grid>
          </Grid>
        </>
      </Section>
      <Divider />
    </div>
  );
};

CompanyPrivacy.propTypes = {
  data: PropTypes.object,
};

export default CompanyPrivacy;
